import React, { useState, useEffect } from "react"
import { apiJSONURL } from "../../../App"
import { useGlobalContext } from "../../data/GlobalContext"

export default function ModulesPeraBayong({ closeModal }) {
  const { username } = useGlobalContext()
  const [activeSection, setActiveSection] = useState("pob")
  const [prizeType, setPrizeType] = useState(null)
  const [prizeValue, setPrizeValue] = useState(null)
  const [message, setMessage] = useState("")
  const [loading, setLoading] = useState(false)
  const [bayongSubmitted, setBayongSubmitted] = useState(false)
  const [freeCredits, setFreeCredits] = useState(null)

  const [awardedFlag, setAwardedFlag] = useState(null)
  const [prizeChoice, setPrizeChoice] = useState("")
  const [mobile, setMobile] = useState("")
  const [email, setEmail] = useState("")
  const [showInputs, setShowInputs] = useState(false)

  const isLoggedIn = Boolean(username)

  // Check if user is already awarded
  useEffect(() => {
    if (!isLoggedIn) return

    const formData = new URLSearchParams()
    formData.append("cmd", "mysteryFridayWinner")
    formData.append("u", username)

    fetch(apiJSONURL, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: formData.toString(),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.s) {
          setAwardedFlag(result.awardedFlag || null)
          setPrizeChoice(result.prizeChoice || "")
          setMobile(result.mobile || "")
          setEmail(result.email || "")

          if (result.awardedFlag === 0 && result.prizeChoice === "ITEM") {
            setShowInputs(true)
          }

          if (result.awardedFlag === 1) {
            setPrizeType(result.prizeChoice)
            setPrizeValue("Already claimed. Thank you!")
          }
        } else {
          setMessage(result.e || "An error occurred.")
        }
      })
  }, [username])

  function decodeHTMLEntities(text) {
    const element = document.createElement("div")
    element.innerHTML = text
    return element.textContent
  }

  const handleRedeem = async (type) => {
    if (!isLoggedIn) {
      setMessage("Please log in to redeem.")
      return
    }

    setLoading(true)
    setMessage("Processing...")

    const formData = new URLSearchParams()
    formData.append("cmd", "redeemMysteryFriday")
    formData.append("prize", type)
    formData.append("u", username)

    try {
      const res = await fetch(apiJSONURL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formData.toString(),
      })
      const data = await res.json()

      if (data.s) {
        setPrizeType(type)
        setPrizeValue(data.s)

        if (type === "ITEM") {
          setShowInputs(true)
        }

        if (type === "FREE_CREDIT") {
          setFreeCredits(data.freeCredits)
        }

        // if (data.freeCredits === 0) {
        //   // Better luck next time!
        // } else {

        // }

        setPrizeType(type)
        // setPrizeValue(data.s)
        setPrizeValue(decodeHTMLEntities(data.s))

        setMessage("")
      } else {
        setMessage(data.e || "An error occurred.")
      }
    } catch (err) {
      console.error(err)
      setMessage("An error occurred, please try again.")
    } finally {
      setLoading(false)
    }
  }

  const handleBayongSubmit = async (e) => {
    e.preventDefault()

    if (!isLoggedIn) {
      setMessage("Please log in to update your details.")
      return
    }

    if (!mobile || !email) {
      setMessage("Please enter both mobile and email.")
      return
    }

    setLoading(true)
    setMessage("Processing…")

    const formData = new URLSearchParams()
    formData.append("cmd", "updateMysteryFriday")
    formData.append("mobile", mobile)
    formData.append("email", email)
    formData.append("u", username)

    try {
      const res = await fetch(apiJSONURL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formData.toString(),
      })
      const data = await res.json()

      if (data.s) {
        setMessage(data.s)
        setBayongSubmitted(true)
      } else {
        setMessage(data.e || "An unknown error occurred.")
      }
    } catch (err) {
      console.error(err)
      setMessage("Network error, please try again.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="promotion-module-pop-container">
      <div className="promotion-module-container">
        <button onClick={closeModal} className="promotion-close-btn">
          Close
        </button>

        <div className="promotion-pob-module-main promotion-module-main">
          <img
            src="/images/promotions/promotion-assets/pob/pob-girl-asset.webp"
            className="pob-img-girl-asset"
            alt="Pera O Bayong"
          />

          {/* User hasn't selected a prize yet */}
          {prizeType === null && (
            <div className="promotion-module-content">
              <img
                src="/images/promotions/promotion-assets/pob/pob-title-assets.webp"
                className="pob-img-title"
                alt="Pera O Bayong"
              />
              <div className="pob-selection">
                <div
                  onClick={() => handleRedeem("FREE_CREDIT")}
                  className="pob-items bayong-item"
                >
                  <img
                    src="/images/promotions/promotion-assets/pob/pera-icon.webp"
                    alt="Pera Icon"
                  />
                </div>
                <div
                  onClick={() => handleRedeem("ITEM")}
                  className="pob-items bayong-item"
                >
                  <img
                    src="/images/promotions/promotion-assets/pob/bayong-icon.webp"
                    alt="Bayong Icon"
                  />
                </div>
              </div>
              <span className="pob-message-text">Please choose your prize</span>
              <span className="pob-qualify-text-status">
                You are Qualified!
              </span>
            </div>
          )}

          {/* FREE_CREDIT Selected */}
          {prizeType === "FREE_CREDIT" && (
            <div className="choose-pera-container">
              <img
                src="/images/promotions/promotion-assets/pob/pob-title-assets.webp"
                className="pob-img-title"
                alt="Pera O Bayong"
              />
              <h2>
                {freeCredits === 0
                  ? "Better Luck next time"
                  : "Congratulations"}
              </h2>
              <p className="choose-pera-container--redeemed">{prizeValue}</p>
            </div>
          )}

          {/* ITEM Selected */}
          {prizeType === "ITEM" && (
            <div className="choose-bayong-container">
              <img
                className="choose-bayong-container--img"
                src="/images/promotions/promotion-assets/pob/pob-title-assets.webp"
                alt="Pera O Bayong"
              />
              <h2>
                {freeCredits === 0
                  ? "Better Luck next time"
                  : "Congratulations"}
              </h2>
              <div
                className="choose-bayong-prize"
                dangerouslySetInnerHTML={{ __html: prizeValue }}
              ></div>

              {/* Show inputs only if needed */}
              {showInputs && !bayongSubmitted && (
                <form
                  className="choose-bayong-prize-form"
                  onSubmit={handleBayongSubmit}
                >
                  <input
                    type="number"
                    inputMode="numeric"
                    placeholder="Mobile Number"
                    name="mobile"
                    maxLength={11}
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                  />
                  <input
                    type="email"
                    placeholder="Email Address"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {message && <p className="bayong-feedback">{message}</p>}
                  <button type="submit" disabled={loading}>
                    {loading ? "Submitting…" : "Submit"}
                  </button>
                </form>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
